import { render } from "./standard-table.vue?vue&type=template&id=7293d5c1&scoped=true"
import script from "./standard-table.vue?vue&type=script&lang=js"
export * from "./standard-table.vue?vue&type=script&lang=js"

import "./standard-table.vue?vue&type=style&index=0&id=7293d5c1&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7293d5c1"]])

export default __exports__